import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function Faq({ items, title, subtitle }) {
  const [open, setOpen] = useState(0);

  return (
    <section data-testid="faq-section" className="bg-white py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <div className="text-sm uppercase tracking-[0.25em] text-[#066ec4] font-bold mb-4">
            Questions fréquentes
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#00367e] leading-[1.1]">
            {title || (<>Tout savoir sur le <span className="dh-underline">dégraissage de hotte</span></>)}
          </h2>
          {subtitle && <p className="mt-5 text-lg text-slate-700">{subtitle}</p>}
        </div>

        <div className="divide-y divide-slate-100 border-y border-slate-100">
          {items.map((it, i) => {
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-toggle-${i}`}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 py-6 text-left group"
                >
                  <span className="text-lg md:text-xl font-bold text-[#00367e] group-hover:text-[#066ec4] transition-colors">{it.q}</span>
                  <ChevronDown
                    size={22}
                    className={`shrink-0 text-[#00367e] transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                  />
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-[400px] pb-6" : "max-h-0"}`}>
                  <p className="text-slate-700 leading-relaxed text-[16px]">{it.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
